import { Caret } from '@cmsgov/ds-medicare-gov';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../../common/analytics';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H2 from '../../common/components/h2';
import SubHeading from '../../common/components/sub.heading.section';
import { TermsAndConditions } from '../../common/components/terms.and.conditions';
import TranslatedSpan from '../../common/components/translated.span';
import capitalizeFirstLetter from '../../common/functions/capitalize.first.letter';
import translate from '../../common/functions/translate';
import the from '../../common/objects/the';


export default function TroubleLoggingSection() {
    const [termsAndConditionsDisplayed, setTermsAndConditionsDisplayed] = useState(false);
    const toggleTermsAndConditions = () => setTermsAndConditionsDisplayed(current => !current);
    const [expand, setExpand] = useState(false);
    const [display, setDisplay] = useState(false);


    return <>
        <Div isRow={true}>
            <Div cols={12} colsSM={12} colsMD={10} colsLG={9} colsXL={8}>
                <Div
                    isRow={true}
                    paddingySM={1}
                    paddingyMD={2}
                    paddingyLG={3}
                    paddingBottomXL={1}>
                    <Div cols={12}>
                        <H2>
                            <TranslatedSpan english={'Trouble logging in?'}/>
                        </H2>
                    </Div>
                </Div>

                <Div isRow={true}>
                    <Div cols={12}>
                        <Div marginTop={0}>
                            <Div>
                                <Link style={{
                                    color: the.color.tarheelBlue
                                }}
                                to="/forgot-username-and-password"
                                onClick={trackLinkClick}
                                >
                                    <TranslatedSpan english={'Forgot username and password'}/>
                                </Link>
                            </Div>
                        </Div>
                    </Div>
                </Div>

                <Div isRow={true}>
                    <Div cols={12}>
                        <Div marginTop={0}>
                            <Div>
                                <Link style={{
                                    color: the.color.tarheelBlue
                                }}
                                to="/find-my-account"
                                onClick={trackLinkClick}
                                >
                                    {capitalizeFirstLetter(translate('Find My Account').toLowerCase())}
                                </Link>
                            </Div>
                        </Div>
                    </Div>
                </Div>

                <Div isRow={true}>
                    <Div cols={12} colsSM={12} colsMD={10} colsLG={9} colsXL={9} paddingTop={5}>
                        <Div>
                            <SubHeading style={{
                                fontSize: 14,
                                fontWeight: 400
                            }}>
                                <TranslatedSpan english={'Using a shared or public computer? Be sure to log out and close all browser windows when you\'re done. This will help keep your information secure.'}/>
                            </SubHeading>
                        </Div>
                    </Div>
                </Div>
                <Div isRow={true}>
                    <Div cols={12} colsSM={12} colsMD={10} colsLG={10} colsXL={10}>
                        <Div style={{
                            color: the.color.lighterGrey,
                            fontFamily: 'Rubik',
                            fontSize: 14,
                            paddingTop: 20,
                            marginBottom: 50
                        }}>
                            {`${translate('By accessing this site, you agree to our')} `}
                            <Button
                                aria-label={translate(expand ? 'Collapse' : 'Expand')}
                                color={'blue'}
                                displayAs={'link'}
                                onClick={toggleTermsAndConditions}
                                style={{
                                    fontSize: '0.9em',
                                    padding: 0,
                                }}
                            >
                                <span
                                    style={{
                                        color: the.color.tarheelBlue,
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                    }}>
                                    {`${translate('Terms and Conditions')}  `}
                                </span>
                                <span onClick={() => {
                                    setExpand(!expand);
                                    setDisplay(!display);
                                }}>
                                    <Caret up={expand}></Caret>
                                </span>
                            </Button>
                            <Div style={{display: termsAndConditionsDisplayed ? 'block' : 'none'}}>
                                <TermsAndConditions />
                                <p>
                                    <span
                                        style={{
                                            color: the.color.tarheelBlue,
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                        }}
                                        onClick={toggleTermsAndConditions}>
                                        <TranslatedSpan english={'Read less'}/>{' - '}
                                    </span>
                                </p>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
        </Div>
    </>
}
